
import styled from 'styled-components';
import { SectionWithSectorProps } from './query';
import Button_v2 from '@/components/molecules/Button/index';
import SectorCard from '@/components/molecules/SectorCard';
import SectorCardImage from '@/components/molecules/SectorCardImage';
import Text from '@/components/molecules/Text';
import Title_v2 from '@/components/molecules/Title/index';
import devices from '@/utilities/devices';
import { renderUnderline } from '@/utilities/functions';

const SectorCardsContainer = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	padding: 3rem 0;

	@media screen and (${devices.mobile}) {
		display: block;
		padding: 1.8rem 0;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		padding: 2rem 0;
	}
`;
// #endregion

const SectionWithSector = ({ sectionWithSectorData }: { sectionWithSectorData: SectionWithSectorProps }) => {
	return (
		<>
			<Title_v2
				align={sectionWithSectorData.title.alignedAt}
				underlineColor={sectionWithSectorData.title.underlineColor}
			>
				{renderUnderline(sectionWithSectorData.title.titlePieces)}
			</Title_v2>
			{sectionWithSectorData.description && (
				<Text textAlign='center'>
					{sectionWithSectorData.description}
				</Text>
			)}
			<SectorCardsContainer>
				{
					sectionWithSectorData.sector.data.attributes.content.map(
						(sectorComponent: any, index) => {
							switch (sectorComponent.__typename) {
								case 'ComponentCardSector': {
									return (
										<SectorCard
											href={sectorComponent.url}
											icon={sectorComponent.icon.name}
											key={index}
											listOfJobs={sectorComponent.listOfJobs}
											title={sectorComponent.title}
										/>
									);
								}
								case 'ComponentCardSectorWithImage': {
									return (
										<SectorCardImage
											icon={sectorComponent.icon.name}
											image={{
												alt: sectorComponent.image.data.attributes.alternativeText ,
												src: sectorComponent.image.data.attributes.url,
											}}
											href={sectorComponent.url}
											key={index}
											title={sectorComponent.title}
										/>
									);
								}
							}
						},
					)
				}
			</SectorCardsContainer>
			{
				sectionWithSectorData.buttons && (
					sectionWithSectorData.buttons.map(
						(button, index) => (
							<Button_v2
								gtm_id={button.trackerId}
								href={button.url}
								key={index}
								openOnNewTab={button.newTab}
								text={button.text}
								version={button.variant}
							/>
						),
					)
				)
			}
		</>
	);
};

export default SectionWithSector;
